import React, { useState } from 'react';
import {
  CustomButton,
} from "../../components";

const Icon = ({ name, size = 18 }) => (
  <span 
    className="material-icons" 
    style={{ fontSize: size, lineHeight: 1, verticalAlign: 'middle' }}
  >
    {name}
  </span>
);

const SampleButtonUsage = () => {
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const handleLoadingClick = (setLoading) => {
    setLoading(true);
    setTimeout(() => setLoading(false), 2000);
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '2rem', color: '#1f2937' }}>CustomButton Usage Examples</h1>

      {/* Basic Variants */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Basic Variants</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <CustomButton variant="primary">Primary</CustomButton>
          <CustomButton variant="secondary">Secondary</CustomButton>
          <CustomButton variant="success">Success</CustomButton>
          <CustomButton variant="danger">Danger</CustomButton>
          <CustomButton variant="warning">Warning</CustomButton>
          <CustomButton variant="info">Info</CustomButton>
          <CustomButton variant="light">Light</CustomButton>
          <CustomButton variant="dark">Dark</CustomButton>
        </div>
      </section>

      {/* Outline Variants */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Outline Variants</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <CustomButton variant="outline-primary">Outline Primary</CustomButton>
          <CustomButton variant="outline-secondary">Outline Secondary</CustomButton>
          <CustomButton variant="outline-success">Outline Success</CustomButton>
          <CustomButton variant="outline-danger">Outline Danger</CustomButton>
          <CustomButton variant="outline-warning">Outline Warning</CustomButton>
          <CustomButton variant="outline-info">Outline Info</CustomButton>
          <CustomButton variant="outline-dark">Outline Dark</CustomButton>
        </div>
      </section>

      {/* Sizes */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Sizes</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center' }}>
          <CustomButton variant="primary" size="sm">Small</CustomButton>
          <CustomButton variant="primary" size="md">Medium</CustomButton>
          <CustomButton variant="primary" size="lg">Large</CustomButton>
        </div>
      </section>

      {/* Rounded Buttons */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Rounded Buttons</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <CustomButton variant="primary" rounded>Rounded Primary</CustomButton>
          <CustomButton variant="success" rounded>Rounded Success</CustomButton>
          <CustomButton variant="outline-danger" rounded>Rounded Outline</CustomButton>
        </div>
      </section>

      {/* Buttons with Icons */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Buttons with Icons</h2>
        
        <h3 style={{ marginBottom: '0.5rem', color: '#6b7280', fontSize: '0.9rem' }}>Icon on Left</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', marginBottom: '1rem' }}>
          <CustomButton variant="primary" icon={<Icon name="search" />} iconPosition="left">
            Search
          </CustomButton>
          <CustomButton variant="success" icon={<Icon name="add" />} iconPosition="left">
            Add New
          </CustomButton>
          <CustomButton variant="info" icon={<Icon name="download" />} iconPosition="left">
            Download
          </CustomButton>
          <CustomButton variant="warning" icon={<Icon name="upload" />} iconPosition="left">
            Upload
          </CustomButton>
          <CustomButton variant="secondary" icon={<Icon name="settings" />} iconPosition="left">
            Settings
          </CustomButton>
        </div>

        <h3 style={{ marginBottom: '0.5rem', color: '#6b7280', fontSize: '0.9rem' }}>Icon on Right</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <CustomButton variant="primary" icon={<Icon name="arrow_forward" />} iconPosition="right">
            Continue
          </CustomButton>
          <CustomButton variant="outline-primary" icon={<Icon name="east" />} iconPosition="right">
            Next Step
          </CustomButton>
          <CustomButton variant="success" icon={<Icon name="send" />} iconPosition="right">
            Send
          </CustomButton>
        </div>
      </section>

      {/* Common Icon Buttons */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Common Icon Buttons</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <CustomButton variant="primary" icon={<Icon name="home" />}>Home</CustomButton>
          <CustomButton variant="secondary" icon={<Icon name="person" />}>Profile</CustomButton>
          <CustomButton variant="success" icon={<Icon name="check_circle" />}>Approve</CustomButton>
          <CustomButton variant="danger" icon={<Icon name="delete" />}>Delete</CustomButton>
          <CustomButton variant="warning" icon={<Icon name="edit" />}>Edit</CustomButton>
          <CustomButton variant="info" icon={<Icon name="visibility" />}>View</CustomButton>
          <CustomButton variant="dark" icon={<Icon name="share" />}>Share</CustomButton>
          <CustomButton variant="outline-primary" icon={<Icon name="favorite" />}>Like</CustomButton>
          <CustomButton variant="outline-success" icon={<Icon name="thumb_up" />}>Approve</CustomButton>
          <CustomButton variant="outline-danger" icon={<Icon name="close" />}>Cancel</CustomButton>
        </div>
      </section>

      {/* Loading States */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Loading States</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <CustomButton 
            variant="primary" 
            loading={loading1}
            loadingText="Saving..."
            icon={<Icon name="save" />}
            onClick={() => handleLoadingClick(setLoading1)}
          >
            Save Changes
          </CustomButton>
          <CustomButton 
            variant="success" 
            loading={loading2}
            loadingText="Submitting..."
            onClick={() => handleLoadingClick(setLoading2)}
          >
            Submit Form
          </CustomButton>
          <CustomButton variant="info" loading loadingText="Processing...">
            Always Loading
          </CustomButton>
        </div>
      </section>

      {/* Disabled States */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Disabled States</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <CustomButton variant="primary" disabled>Primary Disabled</CustomButton>
          <CustomButton variant="success" disabled>Success Disabled</CustomButton>
          <CustomButton variant="outline-primary" disabled>Outline Disabled</CustomButton>
          <CustomButton variant="danger" disabled icon={<Icon name="delete" />}>Delete Disabled</CustomButton>
        </div>
      </section>

      {/* Full Width Buttons */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Full Width Buttons</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '400px' }}>
          <CustomButton variant="primary" fullWidth>
            Full Width Primary
          </CustomButton>
          <CustomButton variant="outline-secondary" fullWidth>
            Full Width Outline
          </CustomButton>
          <CustomButton variant="success" fullWidth icon={<Icon name="save" />}>
            Save All Changes
          </CustomButton>
        </div>
      </section>

      {/* Button Types */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Button Types (for Forms)</h2>
        <form onSubmit={(e) => { e.preventDefault(); alert('Form submitted!'); }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
            <CustomButton type="submit" variant="success" icon={<Icon name="check" />}>
              Submit
            </CustomButton>
            <CustomButton type="reset" variant="warning" icon={<Icon name="refresh" />}>
              Reset
            </CustomButton>
            <CustomButton type="button" variant="secondary" icon={<Icon name="cancel" />}>
              Cancel
            </CustomButton>
          </div>
        </form>
      </section>

      {/* Practical Examples */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Practical Examples</h2>

        {/* Card Actions */}
        <div style={{ 
          border: '1px solid #e5e7eb', 
          borderRadius: '8px', 
          padding: '1.5rem', 
          marginBottom: '1rem',
          maxWidth: '400px'
        }}>
          <h3 style={{ margin: '0 0 1rem 0', color: '#1f2937' }}>Card Title</h3>
          <p style={{ color: '#6b7280', marginBottom: '1rem' }}>
            This is a sample card with action buttons.
          </p>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <CustomButton variant="primary" size="sm" icon={<Icon name="visibility" size={16} />}>
              View Details
            </CustomButton>
            <CustomButton variant="outline-secondary" size="sm" icon={<Icon name="close" size={16} />}>
              Cancel
            </CustomButton>
          </div>
        </div>

        {/* Delete Confirmation */}
        <div style={{ 
          border: '1px solid #fecaca', 
          borderRadius: '8px', 
          padding: '1.5rem', 
          backgroundColor: '#fef2f2',
          maxWidth: '400px',
          marginBottom: '1rem'
        }}>
          <h3 style={{ margin: '0 0 0.5rem 0', color: '#dc2626' }}>
            <Icon name="warning" size={20} /> Delete Item?
          </h3>
          <p style={{ color: '#6b7280', marginBottom: '1rem' }}>
            This action cannot be undone.
          </p>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <CustomButton variant="danger" size="sm" icon={<Icon name="delete" size={16} />}>
              Delete
            </CustomButton>
            <CustomButton variant="outline-secondary" size="sm">
              Cancel
            </CustomButton>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          maxWidth: '400px',
          padding: '1rem',
          backgroundColor: '#f9fafb',
          borderRadius: '8px'
        }}>
          <CustomButton variant="outline-primary" size="sm" icon={<Icon name="arrow_back" size={16} />}>
            Previous
          </CustomButton>
          <CustomButton variant="primary" size="sm" icon={<Icon name="arrow_forward" size={16} />} iconPosition="right">
            Next
          </CustomButton>
        </div>
      </section>

      {/* Social Actions */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Social Actions</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <CustomButton variant="outline-danger" icon={<Icon name="favorite_border" />}>
            Like
          </CustomButton>
          <CustomButton variant="outline-primary" icon={<Icon name="chat_bubble_outline" />}>
            Comment
          </CustomButton>
          <CustomButton variant="outline-info" icon={<Icon name="share" />}>
            Share
          </CustomButton>
          <CustomButton variant="outline-warning" icon={<Icon name="bookmark_border" />}>
            Save
          </CustomButton>
        </div>
      </section>

      {/* File Actions */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>File Actions</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <CustomButton variant="primary" icon={<Icon name="cloud_upload" />}>
            Upload File
          </CustomButton>
          <CustomButton variant="success" icon={<Icon name="cloud_download" />}>
            Download
          </CustomButton>
          <CustomButton variant="info" icon={<Icon name="print" />}>
            Print
          </CustomButton>
          <CustomButton variant="secondary" icon={<Icon name="content_copy" />}>
            Copy
          </CustomButton>
          <CustomButton variant="warning" icon={<Icon name="folder_open" />}>
            Open Folder
          </CustomButton>
        </div>
      </section>

      {/* All Sizes with Icons */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>All Sizes with Icons</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center' }}>
          <CustomButton variant="primary" size="sm" icon={<Icon name="add" size={16} />}>
            Small
          </CustomButton>
          <CustomButton variant="primary" size="md" icon={<Icon name="add" size={18} />}>
            Medium
          </CustomButton>
          <CustomButton variant="primary" size="lg" icon={<Icon name="add" size={22} />}>
            Large
          </CustomButton>
        </div>
      </section>

      {/* Icon Reference */}
      <section style={{ marginBottom: '3rem' }}>
        <h2 style={{ marginBottom: '1rem', color: '#374151' }}>Popular Google Material Icons</h2>
        <p style={{ color: '#6b7280', marginBottom: '1rem' }}>
          Browse all icons at: <a href="https://fonts.google.com/icons" target="_blank" rel="noopener noreferrer">fonts.google.com/icons</a>
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <CustomButton variant="outline-secondary" icon={<Icon name="home" />}>home</CustomButton>
          <CustomButton variant="outline-secondary" icon={<Icon name="menu" />}>menu</CustomButton>
          <CustomButton variant="outline-secondary" icon={<Icon name="search" />}>search</CustomButton>
          <CustomButton variant="outline-secondary" icon={<Icon name="settings" />}>settings</CustomButton>
          <CustomButton variant="outline-secondary" icon={<Icon name="person" />}>person</CustomButton>
          <CustomButton variant="outline-secondary" icon={<Icon name="mail" />}>mail</CustomButton>
          <CustomButton variant="outline-secondary" icon={<Icon name="notifications" />}>notifications</CustomButton>
          <CustomButton variant="outline-secondary" icon={<Icon name="shopping_cart" />}>shopping_cart</CustomButton>
          <CustomButton variant="outline-secondary" icon={<Icon name="schedule" />}>schedule</CustomButton>
          <CustomButton variant="outline-secondary" icon={<Icon name="location_on" />}>location_on</CustomButton>
        </div>
      </section>

    </div>
  );
};

export default SampleButtonUsage;